define('v3/Pages/AbilityGraph/Components/Toggle/Toggle.Component',[
	'knockout',
	'moment',
	'v3/Pages/AbilityGraph/Services/Backend/backendReport',
	'v3/Common/Services/Frontend/Frontend.Service',
	'text!v3/Pages/AbilityGraph/Components/Toggle/Toggle.Component.html',
	'v3/Common/Bindings/Mask.Binding'
], function (ko, moment, backendReport, frontend, template) {
	function toggle (params) {
		var self = this;
		var openEditTargetAbilityDialog = params.openEditTargetAbilityDialog;
		var targetAbilityCalculationChanged = params.targetAbilityCalculationChanged;

		self.targetAbility = params.targetAbility;
		self.targetAbilityPercentile = ko.observable(0);
		self.targetAbilityLastAutomaticUpdated = ko.observable();
		self.isActive = ko.observable(true);
		self.isLoading = ko.observable(true);

		self.targetAbility.subscribe(function (targetAbility) {
			self.targetAbilityLastAutomaticUpdated(null);
			var percentile = (targetAbility || {}).percentile !== undefined ? targetAbility.percentile : 0;
			self.targetAbilityPercentile(percentile);

			var lastUpdated = (targetAbility || {}).lastAutomaticUpdate !== undefined ? targetAbility.lastAutomaticUpdate : null;
			if (lastUpdated) {
				self.targetAbilityLastAutomaticUpdated(moment.utc(lastUpdated).format('ll'));
			}

			var isSetAutomatically = (targetAbility || {}).isSetAutomatically !== undefined ? targetAbility.isSetAutomatically : true;
			self.isActive(isSetAutomatically);

			self.isLoading(false);
		});

		self.toggleActiveState = function () {
			// if previous toggle state === !isActive,
			// it means the user is switching to automatic calculation
			if (!self.isActive()) {
				self.setTargetAbilityToAutomatic();
			} else {
				self.setTargetAbilityToManual();
			}
		};

		self.setTargetAbilityToManual = function () {
			if (!openEditTargetAbilityDialog()) {
				return;
			}

			// once the user changes the target ability
			// self.targetAbility observable will be notified with the new values and isActive state
			var openDialog = openEditTargetAbilityDialog();
			openDialog();
		};

		self.setTargetAbilityToAutomatic = function () {
			if (self.isLoading()) {
				return;
			}

			self.isLoading(true);

			backendReport.updateUserTargetAbilityPercentile(params.subjectGroupId(), params.pupil().userId, null, true)
				.done(function (result) {
					if (result && result.success) {
						self.targetAbilityPercentile(result.targetPercentile);
						self.targetAbilityLastAutomaticUpdated(result.lastAutomaticUpdate);
						self.isActive(true);
						targetAbilityCalculationChanged({
							percentile: result.targetPercentile,
							ability: result.targetAbility,
							isSetAutomatically: true,
							lastAutomaticUpdate: result.lastAutomaticUpdate
						});
					} else {
						frontend.notification.ajax.error();
					}
				})
				.fail(function () {
					frontend.notification.ajax.error();
				})
				.always(function () {
					self.isLoading(false);
				});
		};

		return self;
	}

	return { viewModel: toggle, template: template };
});
